import type { ReactElement } from 'react';
import { components, MultiValueRemoveProps } from 'react-select';
import { SelectIconButton } from '../Select.styles';
import { Icon } from '../../../icons/Icon.component';
import { ILegacySelectOptionData, LegacySelectComponentProps, LegacySelectOptionGroup } from '../Select.types';

type SelectMultiValueRemoveProps = LegacySelectComponentProps<
  MultiValueRemoveProps<ILegacySelectOptionData, boolean, LegacySelectOptionGroup>
>;

export const MultiValueRemove = (props: SelectMultiValueRemoveProps): ReactElement => (
  <components.MultiValueRemove<ILegacySelectOptionData, boolean, LegacySelectOptionGroup> {...props}>
    {/*
     A workaround for the `react-select-event` `clearFirst` option that is bound to search for an svg with aria-hidden
     https://github.com/romgain/react-select-event/issues/53
     */}
    <svg aria-hidden style={{ display: 'none' }} />
    <SelectIconButton variant={props.selectProps.variant}>
      <Icon icon={'xmark-regular'} size={10} />
    </SelectIconButton>
  </components.MultiValueRemove>
);
